import { createAction, props } from '@ngrx/store'
import { OfflineTrackerAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const offlineTrackerPrefix = '[offline-tracker]'

export const save_offline_tracker_action = createAction(
  `${offlineTrackerPrefix} save_offline_tracker_action`,
  props<{ offlineTracker: OfflineTrackerAPIModel; routeTo: string }>()
)

export const save_offline_tracker_success_action = createAction(
  `${offlineTrackerPrefix} save_offline_tracker_success_action`,
  props<{ offlineTracker: OfflineTrackerAPIModel; routeTo: string }>()
)

export const FETCH_OFFLINE_TRACKER_DETAILS = createAction(
  `${offlineTrackerPrefix} fetch_offline_tracker_details`,
  props<{ id: string }>()
)

export const FETCH_OFFLINE_TRACKER_DETAILS_SUCCESS = createAction(
  `${offlineTrackerPrefix} fetch_offline_tracker_details_success`,
  props<{ offlineTracker: OfflineTrackerAPIModel }>()
)

export const UPDATE_OFFLINE_TRACKER_ACTION = createAction(
  `${offlineTrackerPrefix} update_offline_tracker_action`,
  props<{ offlineTracker: Partial<OfflineTrackerAPIModel>; id: string; routeTo: string }>()
)

export const UPDATE_OFFLINE_TRACKER_SUCCESS_ACTION = createAction(
  `${offlineTrackerPrefix} update_offline_tracker_success_action`,
  props<{ offlineTracker: Partial<OfflineTrackerAPIModel>; routeTo: string }>()
)

export const LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS = createAction(
  `${offlineTrackerPrefix} load_offline_tracker_summary_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS_SUCCESS = createAction(
  `${offlineTrackerPrefix} load_offline_tracker_summary_details_success`,
  props<PaginatedAPI<OfflineTrackerAPIModel>>()
)
